import { RQ_EDIT_LIST, RQ_LIST_BY_ID, RQ_ALL_LIST, RQ_LIST_ENTRIES, callAll } from 'Utils';
import { patchList } from 'Services';
import { AxiosResponse } from 'axios';
import useAlertBanner from 'Hooks/reduxHelperHooks/useAlertBanner';
import useReduxModal from 'Hooks/reduxHelperHooks/useReduxModal';
import useSingleList404Modal from 'Hooks/reduxHelperHooks/useSingleList404Modal';

import { useMutation, MutationOptions, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export default function useEditList(
    id: number,
    {
        mutationOptions
    }: { mutationOptions: Omit<MutationOptions<AxiosResponse<PatchList>, any, any, any>, 'mutationKey'> }
) {
    const { addAlert } = useAlertBanner();
    const { listNotFound } = useSingleList404Modal();
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    const { addTechnicalErrorModal } = useReduxModal();

    const defaultSuccessHandler = () => {
        queryClient.invalidateQueries([RQ_LIST_BY_ID, id]);
        queryClient.invalidateQueries([RQ_ALL_LIST]);
        queryClient.invalidateQueries([RQ_LIST_ENTRIES]);
        addAlert({ id: `list-updated-${Date.now()}`, content: t('listUpdated'), status: 'success' });
    };

    return useMutation([RQ_EDIT_LIST, id], (values: PatchList) => patchList(id, values), {
        ...mutationOptions,
        onSuccess: callAll(defaultSuccessHandler, mutationOptions.onSuccess),
        onError: (error: any, variables, context) => {
            switch (error?.status) {
                case 409: {
                    if (error?.data?.error?.param !== 'name') {
                        addTechnicalErrorModal();
                    }
                    break;
                }
                case 404: {
                    listNotFound();
                    break;
                }
                default:
                    break;
            }
            mutationOptions?.onError?.(error, variables, context);
        }
    });
}
